import React from "react";
import { DetailsKVProps } from "./types";

const EjariWebConfig = {
	rootUrl: "/",
	rootUrlLocale: "/en",
};

interface IUIConfig {
	DetailsKV?: React.ElementType<DetailsKVProps>;
}

const UIConfig: IUIConfig = {};

export default EjariWebConfig;
export { UIConfig };
